import { NavLink } from "react-router";
import React from "react";
import ImgixFluidImage from "./ImgixFluidImage";
import PlaceHolderImage from "./placeHolderImage";

const Card = ({image, standalone = false, readMoreLabel="Read more", title, subtitle, href, color, hasFocalPoint = true, sizes = "(min-width: 1000px) 350px, (min-width: 768px) 400px, 640px", ar, placeHolderImage, className, useImage = true, replacementImage, truncateText = true, isStaff = false, backgroundColor = 0, ...other }) => {

  let link;

  if (href) {
     // all internal links should be relative so as soon as there is an http:// in the url we can assume it is external
    link = (href.indexOf("://")=== -1 && href.indexOf("mailto")=== -1) ? <NavLink to={href} className="box__link-main" aria-label="link to internal page" /> : <a href={href} className="box__link-main" target="_blank" rel="noreferrer" aria-label="link to external page"><div style={{display: 'none'}}>Link</div></a>
  } else {
    link = "";
  }

  const firstImage = image ? <ImgixFluidImage width={340} attribution={image.attribution} image={image} sizes={sizes} ar={ar || 2} focalPoint={image.focalPoint} />  : <PlaceHolderImage image={placeHolderImage} ar={ar || 2} />;
  const finalImage = replacementImage ? replacementImage : firstImage;

  const colors = ["", "box--red", "box--orange"];

  // some cards aren't in 3s. Ths class removes flex 33%
  const standaloneClass = standalone ? "standalone" : "";

  return (
    <div className={`box ${isStaff ? 'box-staff' : ''} ${standaloneClass} box--secondary ${color} ${backgroundColor} ${colors[color]} swiper-slide ${className} `} {...other}>
      <div className={`box__inner ${backgroundColor == 1 ? 'box__background-green' : ''}`}>
        {link}
        {useImage && <figure className="image-fit js-image-fit box__image">{finalImage}</figure>} 
        <div className="box__body">
          <p className={`box__title h6 ${backgroundColor == 1 ? 'text-[#72a84e]' : ''}`}>{title}</p>
          <div dangerouslySetInnerHTML={{ __html: subtitle }} className={`box__subtitle${truncateText ? " truncate-overflow" : ""}`}></div>
          {href && <div className="box__link link-more text-gray-3">{readMoreLabel}</div>}
        </div>
      </div>
    </div>
  );
};

export default Card;
